export default "__VITE_ASSET__CnyT$_xk__"